import { atom } from "jotai";
import type { ActiveTab } from "@/appInterface/windows/VoteWindow/types";
import type { HeaderButtonNames, UserSessionData } from "@/interface/types";

export const zoomAtom = atom<number>(100);

// TODO: types for tool names
export const currentToolAtom = atom<string>("cursor");

type SearchResultStore = {
    total?: number;
    currentIndex?: number;
};
export const searchResultAtom = atom<SearchResultStore>({
    total: 0,
    currentIndex: 0,
});

type BoardInfoStore = Record<string, any>;

export const boardInfoAtom = atom<BoardInfoStore>({});
export const multiCursorsAtom = atom<{
    disableMultiCursors: boolean;
}>({
    disableMultiCursors: false,
});

export const buttonDisabledAtom = atom<Record<string, boolean>>({});

export const usersAtom = atom<{
    users: UserSessionData[];
    trackingSession: string | null;
}>({
    users: [],
    trackingSession: null,
});

export const voteTimerVisibilityAtom = atom<boolean>(false);

export const headerActiveButtonAtom = atom<HeaderButtonNames | null>(null);

export const startVoteVisibilityAtom = atom<boolean>(false);

export const startVoteActiveTabAtom = atom<ActiveTab>("new");

export const activeVoteVisibilityAtom = atom<boolean>(false);
